var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent25(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.429+265.366L703.063+267.239L738.029+580.059L289.717+577.561",
    opacity: 1,
    fill: "#402303"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#ec5643",
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#edae73",
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z",
    fill: "#edae73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.502+90.5366L521.99+90.5366C628.546+90.5366+714.927+176.917+714.927+283.473L714.927+283.473C714.927+295.438+657.483+264.117+657.483+264.117C657.483+264.117+638.523+292.916+625.015+293.463C611.507+294.011+586.927+265.99+586.927+265.99C586.927+265.99+566.946+288.468+550.712+289.717C534.478+290.966+525.112+264.741+509.502+264.117C493.893+263.493+488.898+294.088+470.166+293.463C451.434+292.839+449.561+262.244+432.078+265.366C414.595+268.488+407.727+289.717+393.99+291.59C380.254+293.463+370.263+263.493+370.263+263.493C370.263+263.493+316.566+292.102+316.566+283.473L316.566+283.473C316.566+176.917+402.946+90.5366+509.502+90.5366Z",
    opacity: 1,
    fill: "#402303"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent25);
export default __webpack_public_path__ + "static/media/Student 25.08f3608cda5f8a5783d15020f8803c03.svg";
export { ForwardRef as ReactComponent };